import { cacheKeys } from "@constants/cache-keys";
import { useAuthContext } from "@features/auth/contexts/AuthContext";
import { fetchActivePurchases } from "@features/redeem/helpers/auto-redeem";
import { useGlobalStore } from "@hooks/useGlobalStore";
import { useToast } from "@memorang/ui/components/Toast";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export const useManualRedeemCheck = () => {
	const { userLogicalId } = useAuthContext();
	const queryClient = useQueryClient();
	const { showToast } = useToast();
	const { t } = useTranslation();
	const requestAutoRedeemPrompt = useGlobalStore(
		(state) => state.requestAutoRedeemPrompt,
	);

	const handleRedeemPurchase = async () => {
		if (!userLogicalId) {
			return;
		}
		try {
			const purchases = await queryClient.fetchQuery({
				queryKey: [cacheKeys.activeAccessCodes, userLogicalId],
				queryFn: fetchActivePurchases,
			});
			if (purchases.length === 0) {
				showToast({ message: t("account.redeemPurchaseNoneFound") });
				return;
			}
			requestAutoRedeemPrompt();
		} catch {
			showToast({ message: t("account.redeemPurchaseCheckFailed") });
		}
	};

	return { handleRedeemPurchase };
};
